


















import {
  computed,
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import { useMagentoConfiguration, useProductPageState } from '~/composables';
import { removeDomain } from '~/helpers/productHelpers';
import { CompatibilityListInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'ProductTabCompatibilityList',

  props: {
    compatibilityList: {
      type: Array as PropType<CompatibilityListInterface[]>,
      default: () => [],
    },
  },

  setup(props) {
    const { brand } = useProductPageState();
    const { magentoBaseUrl } = useMagentoConfiguration();

    const getBrandFromUrl = (urlPath) => {
      const parts = urlPath.split('/').filter(Boolean);

      if (parts.length > 1) {
        return parts[1];
      }

      return null;
    };

    let rawList = props.compatibilityList.map(({ url, name }) => {
      const link = removeDomain(url, magentoBaseUrl.value);
      const itemBrand = getBrandFromUrl(link);
      const brandTitle = `${itemBrand || brand.value} `;

      return {
        name: `${brandTitle || ''}${name}`,
        link,
      };
    });

    rawList = rawList.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    const list = computed(() => rawList);
    return {
      brand,
      list,
    };
  },
});
